import PropTypes from "prop-types";
import EngagementCard from "./tv-engagement-card.js";
import EmptyStateMessage from "components/lists/empty-state-message-tv";
import TVIconViewed from "../../../../images/tv-icon1.svg";

const EngagementCardThankview = ({ contact = {}, engagement_data = [] }) => {
  return engagement_data.length === 0 ? (
    <EmptyStateMessage
      className="empty-state-message--thankview"
      icon="logo"
      iconKit="tv"
      text="No ThankView engagements found."
    />
  ) : (
    engagement_data.map(
      ({
        id,
        Campaign: title,
        "Campaign Type": contents,
        Reply: comment,
        date_occurred,
        Clicked: clicked,
        Completed: completed,
        Started: started,
        "Watched 50%": watched,
        Opened: opened,
        Views: views,
        "CTA Clicked": ctaClicked,
        Downloads: downloads,
      }) => (
        <EngagementCard
          key={id}
          id={id}
          title={title}
          contents={contents}
          comment={comment}
          date={date_occurred}
          icon={<img src={TVIconViewed} alt="TVIconViewed" height="40" width="40" />}
          contact={contact}
          clicked={clicked === "true"}
          completed={completed === "true"}
          started={started === "true"}
          watched={watched === "true"}
          opened={opened === "true"}
          viewed={parseInt(views, 10) > 0}
          ctaClicked={parseInt(ctaClicked, 10) > 0}
          downloaded={parseInt(downloads, 10) > 0}
        />
      )
    )
  );
};

EngagementCardThankview.propTypes = {
  contact: PropTypes.object,
  engagement_data: PropTypes.array,
};

export default EngagementCardThankview;
